/**
 * the intersection-observer polyfill
 * is important as it is fairly recent on IOS
 */
import 'intersection-observer';

const options = {
  root: null,
  rootMargin: "150px"
}

const callback = (entries, observer) => {
  entries.forEach(entry => {
    if(entry.isIntersecting) {
      entry.target.setAttribute('load', '');
      observer.unobserve(entry.target);
    }
  });
}

window.lazyResourcesObserver = new IntersectionObserver(callback, options);

lazyResourcesObserver.observe(document.querySelector('lazy-resources'));

class LazyResources extends HTMLElement {
  constructor() {
    super();

    this.resourcesToLoad = Array.from(this.querySelectorAll('[type="javascript/blocked"], [data-href]'));

    window.lazyResourcesObserver.observe(this);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if(this.hasAttribute('load')) {
      this.loadResources();
    }
  }

  static get observedAttributes() { return ['load']; }

  loadResources() {
    this.resourcesToLoad.forEach((resource) => {
      switch (resource.tagName) {
        case 'SCRIPT':
          this.loadScript(resource);
          break;

        case 'LINK':
          this.loadStyle(resource);
          break;
      }
    });

    this.removeAttribute('load');
    this.setAttribute('loaded', '');
  }

  loadScript(resource) {
    const existingScript = document.querySelector(`script[src*="${resource.src.replace('https://', '')}"]:not([type='javascript/blocked'])`);

    if(!existingScript) {
      var newScript = document.createElement('script');
      newScript.src = resource.src;
    }

    resource.remove();

    if(!existingScript) {
      this.appendChild(newScript);
    }
  }

  loadStyle(resource) {
    const newStyle = document.createElement('link');
    newStyle.rel = "stylesheet";
    newStyle.href = resource.dataset.href;

    resource.remove();
    this.appendChild(newStyle);
  }
}

try {
  customElements.define('lazy-resources', LazyResources);
}
catch(e) {
  console.log("lazy-resources already defined", e)
}
